export function concatenateStrings(collectionIds: string[], separator: string = ","): string {
    return collectionIds.reduce((prev, curr) => {
        if (prev !== "") {
            return prev + separator + "'" + curr + "'";
        }

        return "'" + curr + "'";
    }, "");
}

export function concatenateNumbers(collectionIds: string[], separator: string = ","): string {
    return collectionIds.reduce((prev, curr) => {
        if (prev !== "") {
            return prev + separator + curr;
        }

        return curr;
    }, "");
}
